export default "__VITE_ASSET__8f235fae__"